import { Loader2 } from 'lucide-react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

type EntityType = 'expense' | 'lien';

interface DeleteConfirmDialogProps {
  entityType: EntityType;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting?: boolean;
}

const DIALOG_COPY: Record<EntityType, { title: string; description: string }> =
  {
    expense: {
      title: 'Delete expense?',
      description:
        'This will remove the expense and all allocations. This cannot be undone.',
    },
    lien: {
      title: 'Delete lien?',
      description:
        'This will remove the lien record. Expense allocations will not be affected.',
    },
  };

export const DeleteConfirmDialog = ({
  entityType,
  open,
  onConfirm,
  onCancel,
  isDeleting = false,
}: DeleteConfirmDialogProps) => {
  const { title, description } = DIALOG_COPY[entityType];

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen && !isDeleting) {
      onCancel();
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting} onClick={onCancel}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-white hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
